import {
  Padding,
  styled,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import { ITableColumn } from "components/interfaces";
import { lang } from "i18nLang";

const HiddenSpan = styled("span")({
  border: 0,
  clip: "rect(0 0 0 0)",
  height: 1,
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  top: 20,
  width: 1,
});

const SortLabel = ({
  label,
  dataKey,
  orderBy,
  order = "asc",
  onRequestSort,
}) => {
  const isOrdering = orderBy === dataKey;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableSortLabel
      active={isOrdering}
      direction={isOrdering ? (order as any) : "asc"}
      onClick={createSortHandler(dataKey)}
    >
      {label}
      {isOrdering && (
        <HiddenSpan>
          {order === "desc" ? "sorted descending" : "sorted ascending"}
        </HiddenSpan>
      )}
    </TableSortLabel>
  );
};

interface IProps {
  className?: string;
  columns: any;
  actionColumn?: boolean;
  actionWidth?: number;
  orderBy: string;
  order?: "asc" | "desc";
  onRequestSort?: Function;
}

const SortableHeadTable = ({
  className,
  columns,
  actionColumn = false,
  actionWidth = 150,
  orderBy,
  order = "asc",
  onRequestSort = () => {},
}: IProps) => {
  const clmns = actionColumn
    ? [
        ...columns,
        { dataKey: "acao", label: lang("actions"), width: actionWidth },
      ]
    : columns;

  return (
    <TableHead>
      <TableRow className={className}>
        {clmns.map((column: ITableColumn, index: number) => (
          <TableCell
            key={`table-head-cell-${index}`}
            component="th"
            align={column.align as any}
            style={{
              width: column.width,
              fontWeight: 400,
            }}
            padding={column.padding as Padding}
            sortDirection={orderBy === column.dataKey ? order : false}
          >
            <SortLabel
              label={column.label}
              dataKey={column.dataKey}
              orderBy={orderBy}
              order={order}
              onRequestSort={onRequestSort}
            />
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SortableHeadTable;
